module.exports = __webpack_public_path__ + "img/dp.e925a30a.png";